export default __webpack_public_path__ + "img/ec5fd2813d44229047327699d1d7d85e.png";